import { Reveal, Overline } from "@/components/Reveal";

const STEPS = [
  { n: "01", title: "Precalificación", desc: "Completa el formulario. Revisamos perfil, país y capital disponible para confirmar que el territorio encaja." },
  { n: "02", title: "Llamada estratégica", desc: "Una conversación uno a uno: te mostramos el modelo, los números de tu mercado y resolvemos objeciones." },
  { n: "03", title: "Asignación de territorio", desc: "Firmamos la licencia y reservamos tu zona. Los territorios son limitados por país para proteger tu demanda." },
  { n: "04", title: "Activación y operación", desc: "Recibes plataforma, CRM, campañas y capacitación. En días operas tu negocio digital con soporte continuo." },
];

export function HowItWorks() {
  return (
    <section id="how" data-testid="how-section" className="relative py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="max-w-3xl">
          <Overline>Cómo funciona</Overline>
          <h2 className="font-serif text-4xl sm:text-5xl font-bold tracking-tight text-midnight mt-6 leading-[1.05]">
            Del interés a la operación, en cuatro pasos.
          </h2>
        </Reveal>

        <div className="mt-16 border-t border-midnight/10">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <div className="grid lg:grid-cols-12 gap-6 py-10 border-b border-midnight/10 group hover:bg-ivory transition-colors duration-500 px-0 lg:px-4">
                <div className="lg:col-span-2 font-serif text-5xl lg:text-6xl font-black text-crimson/70 tracking-tighter group-hover:text-crimson transition-colors">
                  {s.n}
                </div>
                <div className="lg:col-span-4">
                  <h3 className="font-serif text-2xl sm:text-3xl font-semibold text-midnight">{s.title}</h3>
                </div>
                <div className="lg:col-span-6">
                  <p className="font-sans text-lg font-light text-midnight/60 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
